import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { LinkModal } from '../../../../components/ATS/LinkModal/LinkModal';
import { Asset } from '../../../../queries/ats/titles/types/asset';
import { ThirdPartySource } from '../../../../queries/ats/titles/types/sources';
import { useAuth } from '../../../../utils/auth-utils';
import StickyHeader from '../../../../views/app/StickyHeader';
import { NoBroadcastView } from '../../../../views/ats-details/no-broadcast-view/no-broadcast-view';

interface ProgramPlayerThirdPartyCatchupDeeplinkProps {
  asset: Asset;
  source: ThirdPartySource;
  channelId: string;
}

export function ProgramPlayerThirdPartyCatchupDeeplink({
  asset,
  source,
  channelId,
}: ProgramPlayerThirdPartyCatchupDeeplinkProps) {
  const { t } = useTranslation();
  const { isGuest } = useAuth();
  const history = useHistory();

  const link = source.links.open || source.links.play;

  if (isGuest) {
    return (
      <div>
        <StickyHeader />
        <NoBroadcastView channelId={channelId} />
      </div>
    );
  }

  // This should never happen. The only time it happens is
  // if the user goes directly to the player.
  if (link === undefined) {
    return (
      <div>
        <StickyHeader />
        <NoBroadcastView channelId={channelId} />
      </div>
    );
  }

  if (source.isSubscribed) {
    return (
      <LinkModal
        id={source.id}
        title={source.name}
        description={t('catchup:popup_description', { name: source.name })}
        primaryButton={{
          title: `${t('continue to')} ${source.name}`,
          url: link,
        }}
        initialOpen={true}
        onClose={() => history.goBack()}
        children={<></>}
      />
    );
  }

  return (
    <div>
      <StickyHeader />
      <NoBroadcastView channelId={channelId} />
    </div>
  );
}
